import { Pill } from "components/atoms/Pill";
import { PillSection } from "components/molecules/PillSection";
import { FC } from "react";

interface PillSectionProps {
  tag?: string;
  category?: string;
  duration?: string;
  pt?: string;
  pb?: string;
}

export const PillComponent: FC<PillSectionProps> = ({ category, tag, duration, pt, pb }) => (
  <PillSection pt={pt} pb={pb}>
    {tag ? <Pill color="purple" text={tag} /> : null}
    {category ? <Pill color="grey" text={category} /> : null}
    {duration && duration}
  </PillSection>
);
